export default function PrivacyPolicy() {
  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <h1 style={styles.title}>Privacy Policy</h1>
        <p style={styles.meta}>MeriLite &nbsp;·&nbsp; Last updated: July 27, 2026</p>

        <section style={styles.section}>
          <h2 style={styles.heading}>1. Introduction</h2>
          <p>MeriLite is a student connection platform. This policy explains what data we collect, why we collect it, and how we use it. By using MeriLite, you agree to the practices described here.</p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>2. Data We Collect</h2>
          <ul style={styles.list}>
            <li><strong>Account information</strong> — name, email address, and profile details you provide during registration.</li>
            <li><strong>Location</strong> — we access your device location to save and display your location within the app for connection and discovery features. Location is only accessed when you grant permission.</li>
            <li><strong>Photos and files</strong> — we access your gallery or file storage only when you choose to upload or save a profile picture or media.</li>
            <li><strong>Microphone</strong> — we access your microphone for audio calls between users. Microphone is only active during a call.</li>
            <li><strong>Camera</strong> (future) — we may request camera access for video calling features in a future update.</li>
            <li><strong>Screen sharing</strong> (future) — we may support screen sharing in a future update for collaborative features.</li>
            <li><strong>Internet</strong> — the app requires internet access to function, including account authentication, messaging, and real-time communication.</li>
            <li><strong>Device information</strong> — basic device data such as OS version and device model, used to improve app performance and compatibility.</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>3. How We Use Your Data</h2>
          <p>We use collected data solely to provide and improve MeriLite's features, including:</p>
          <ul style={styles.list}>
            <li>Creating and managing your account</li>
            <li>Enabling connections and communication between students</li>
            <li>Improving app performance and fixing bugs</li>
            <li>Sending important service-related notifications</li>
          </ul>
          <p>We do not sell your personal data to third parties. We do not use your data for advertising purposes.</p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>4. Data Storage and Security</h2>
          <p>Your data is stored securely on our servers hosted on Render. We use industry-standard practices to protect your information. We retain your data only as long as your account is active or as needed to provide services.</p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>5. Third-Party Services</h2>
          <p>MeriLite uses the following third-party infrastructure:</p>
          <ul style={styles.list}>
            <li><strong>Render</strong> — cloud hosting for our backend servers</li>
          </ul>
          <p>These services have their own privacy policies. We share only the minimum data necessary for them to function.</p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>6. Children's Privacy</h2>
          <p>MeriLite is intended for users aged 13 and above. We do not knowingly collect personal data from children under 13. If you believe a child under 13 has provided us with personal data, please contact us and we will delete it promptly.</p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>7. Your Rights</h2>
          <p>You may request deletion of your account and all associated data at any time by contacting us. You can also update your profile information directly within the app.</p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>8. Changes to This Policy</h2>
          <p>We may update this privacy policy from time to time. We will notify you of significant changes through the app or by email. Continued use of MeriLite after changes constitutes acceptance of the updated policy.</p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>9. Contact Us</h2>
          <p>For any privacy-related questions or data deletion requests, contact us at:</p>
          <p><strong>Email:</strong> <a href="mailto:support@merilite.com" style={styles.link}>support@merilite.com</a></p>
        </section>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    backgroundColor: "#f9f9f9",
    fontFamily: "'Segoe UI', Arial, sans-serif",
    color: "#222",
    padding: "40px 20px",
  },
  content: {
    maxWidth: "720px",
    margin: "0 auto",
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "40px",
    boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
  },
  title: {
    fontSize: "2rem",
    fontWeight: "700",
    marginBottom: "4px",
    color: "#111",
  },
  meta: {
    color: "#888",
    fontSize: "0.9rem",
    marginBottom: "32px",
  },
  section: {
    marginBottom: "28px",
  },
  heading: {
    fontSize: "1.1rem",
    fontWeight: "600",
    marginBottom: "8px",
    color: "#333",
  },
  list: {
    paddingLeft: "20px",
    lineHeight: "1.8",
  },
  link: {
    color: "#4f46e5",
    textDecoration: "none",
  },
};